import React, { useState, useEffect } from "react";
import ModalMissao from "react-modal";
import ModalMissaoDetalhe from "react-modal";
import ModalFeedback from "react-modal";
import ModalFeedbackDetalhe from "react-modal";
import ModalCheckList from "react-modal";
import ModalCheckListDetalhe from "react-modal";
import api from "../../services/api";
import "./style.css";
import { useAppContext } from '../../context/AppContext.js';
import ModalQualificacao from "react-modal";
import PopUp from "../../componente/popup/index.jsx";
import PopUpRefazer from "../../componente/popup/index.jsx";
import FotoPadrao from "../../assets/User.png";

ModalMissao.setAppElement("#root");

function TopBar({ nomeColaborador, foto }) {
    const { DateTime } = require("luxon");
    const { codcolaborador, isGestor, accessKey, selectedCompany, codassinante } = useAppContext(); // Acessa os dados do contexto

    const [abusca, setabusca] = useState("");

    const getFirstDayOfMonth = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual
    const getCurrentDate = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [dt1, setdt1] = useState(getFirstDayOfMonth);
    const [dt2, setdt2] = useState(getCurrentDate);

    const [showformqualificacao, setshowformqualificacao] = useState(false);
    const [coin, setCoin] = useState(0);
    const [coincalculado, setCoinCalculado] = useState(0);
    const [qualificacao, setQualificacao] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenRefazer, setIsOpenRefazer] = useState(false);
    const [codchecklist, setCodCheckList] = useState(0);

    const [missaoModalOpen, setMissaoModalOpen] = useState(false);
    const [missaoDetalheModal, setMissaoDetalheModal] = useState(false);
    const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
    const [feedbackDetalheModal, setFeedbackDetalheModal] = useState(false);
    const [checkListModalOpen, setCheckListModalOpen] = useState(false);
    const [checkListDetalheModal, setCheckListDetalheModal] = useState(false);

    const [checkListDetalheGestor, setCheckListDetalheGestor] = useState(false);

    const [pendentes, setPendentes] = useState({ missoes: 0, mensagens: 0, checklist: 0 });
    const [missaoDetalhe, setMissaoDetalhe] = useState(null);
    const [feedbackDetalhe, setFeedbackDetalhe] = useState(null);
    const [checkListDetalhe, setCheckListDetalhe] = useState(null);

    const [missoes, setMissoes] = useState([]);
    const [feedbacks, setFeedbacks] = useState([]);
    const [checklist, setCheckList] = useState([]);
    const [tarefasEquipe, setTarefasEquipe] = useState([]);
    const [listaProfissionalEquipe, setListaProfissionalEquipe] = useState([]);

    const [buscaMissao, setBuscaMissao] = useState("");
    const [justificativa, setJustificativa] = useState("");
    const [observacao, setObservacao] = useState("");

    const [codcolaboradorequipe, setcodcolaboradorequipe] = useState(0);
    const [aviso, setAviso] = useState("");

    const [edtpositivo, setedtpositivo] = useState("");
    const [edtcodcolaborador, setedtcodcolaborador] = useState(0);
    const [edtfeedback, setedtfeedback] = useState("");
    const [listacolaborador, setlistacolaborador] = useState([]);

    function closeModalQualificacao() {
        setshowformqualificacao(false);
    }

    function InformarConclusao() {
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        if (qualificacao != 0) {
            api
                .put(
                    "/v1/operacoes/tarefafinalizada/concluirtarefa",
                    {
                        dtconclusao: dtcadastro,
                        qualificacao,
                        codchecklist,
                        coinsomar: coin
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(() => {
                    closeModalQualificacao();
                    ListarTarefas();
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        } else {
            alert("Escolha a nota!");
        }
    }

    function InformarRefazer() {
        api
            .put(
                "/v1/operacoes/tarefafinalizada/refazertarefa",
                {
                    codchecklist
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarTarefas();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    const handleConfirma = () => {
        setIsOpen(false);
        setshowformqualificacao(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleConfirmaRefazer = () => {
        setIsOpenRefazer(false);
        InformarRefazer();
    };

    const handleCloseRefazer = () => {
        setIsOpenRefazer(false);
    };

    // Fetch pendentes
    useEffect(() => {
        api.get("/v1/cadastro/colaborador/pendentes", {
            params: { codcolaborador },
            headers: { Authorization: `Bearer ${accessKey}`, }
        })
            .then((response) => {
                setPendentes(response.data);
            })
            .catch((err) => console.error("Erro ao buscar pendências: " + err));
    }, []);

    // Fetch missões/desafios
    const fetchMissoes = () => {
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0") +
            ":" +
            dt.getSeconds().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        api.get("/v1/cadastro/colaborador/missao", {
            params: {
                codcolaborador,
                dtagora: dtcadastro,
                busca: buscaMissao
            }, headers: { Authorization: `Bearer ${accessKey}`, }
        })
            .then((response) => setMissoes(response.data))
            .catch((err) => console.error("Erro ao buscar missões: " + err));
    };

    // Fetch feedbacks
    const fetchFeedbacks = () => {
        api.get("/v1/cadastro/colaborador/feedbacks", {
            params: { codcolaborador },
            headers: { Authorization: `Bearer ${accessKey}`, }
        })
            .then((response) => setFeedbacks(response.data))
            .catch((err) => console.error("Erro ao buscar feedbacks: " + err));
    };

    // Fetch checklist
    const fetchCheckList = () => {
        api.get("/v1/cadastro/colaborador/checklist", {
            params: { codcolaborador },
            headers: { Authorization: `Bearer ${accessKey}`, }
        })
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                setCheckList(data);
            })
            .catch((err) => console.error("Erro ao buscar checklist: " + err));
    };

    function ListarTarefas() {
        api
            .get("/v1/operacoes/tarefafinalizada", {
                params: {
                    busca: abusca,
                    codassinante: codassinante,
                    codempresa: selectedCompany,
                    codgestor: codcolaborador,
                    dt1,
                    dt2
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setTarefasEquipe(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarTarefas();
        },
        [abusca, selectedCompany, dt1, dt2]
    );

    const handleMissaoClick = (missao) => {
        setMissaoDetalhe(missao);
        setMissaoDetalheModal(true);
    };

    const handleFeedbackClick = (feedback) => {
        setFeedbackDetalhe(feedback);
        setFeedbackDetalheModal(true);

        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0") +
            ":" +
            dt.getSeconds().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        // Marcar feedback como lido
        api.post("/v1/cadastro/colaborador/aviso/marcarlido",
            {
                codigo: feedback.codigo,
                dtagora: dtcadastro,
                tipo: feedback.tipo
            },
            {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                fetchFeedbacks();
            })
            .catch((err) => console.error("Erro aceitar missão/desafio: " + err));
    };

    const handleCheckListClick = (check) => {
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0") +
            ":" +
            dt.getSeconds().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        api.post("/v1/cadastro/colaborador/checklist/informaraceite",
            {
                codchecklist: check.codchecklist,
                dttarefafeito: dtcadastro,
                justificativa,
                observacao
            },
            {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                fetchCheckList();
                setCheckListDetalheModal(false);
            })
            .catch((err) => console.error("Erro aceitar missão/desafio: " + err));
    };

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    function FormataData(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy")
            : null;
    }

    function AceitarMissao(missao) {
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0") +
            ":" +
            dt.getSeconds().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        api.post("/v1/cadastro/colaborador/missao/aceitarmissao",
            {
                codigo: missao.codigo,
                dtagora: dtcadastro,
                tipo: missao.tipo
            },
            {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                setMissaoDetalheModal(false);
                fetchMissoes();
            })
            .catch((err) => console.error("Erro aceitar missão/desafio: " + err));
    }

    const concluirTarefa = (cad) => {
        setCodCheckList(cad.codchecklist);
        setCoin(cad.coinssomar);
        setQualificacao(0);
        setIsOpen(true);
    }

    const refazerTarefa = (cad) => {
        setCodCheckList(cad.codchecklist);
        setIsOpenRefazer(true);
    }

    const visualizarDetalhes = (tarefa) => {
        setCheckListDetalhe(tarefa);
        setObservacao(tarefa.observacao);
        setJustificativa(tarefa.justificativa);
        setCheckListDetalheGestor(false);
        setCheckListDetalheModal(true);
    }

    function GerarAviso() {
        if (codcolaboradorequipe === 0) {
            alert("Selecione o profissional");
        } else if (aviso === "") {
            alert("Informe o aviso!");
        } else {
            api
                .post(
                    "/v1/cadastro/colaborador/aviso",
                    {
                        descricao: aviso,
                        visualizado: 'N',
                        codcolaborador: codcolaboradorequipe,
                        codassinante,
                        codempresa: selectedCompany,
                        excluido: "N",
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(() => {
                    alert("Aviso enviado com sucesso!");

                    setAviso("");
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        }
    }

    function EnviarFeedBack() {
        if (edtcodcolaborador === 0) {
            alert("Selecione o profissional");
        } else if (edtfeedback === "") {
            alert("Informe o feedback");
        } else {
            const dt = new Date();
            const date =
                dt.getFullYear() +
                "-" +
                (dt.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                dt.getDate().toString().padStart(2, "0");
            let time =
                dt.getHours().toString().padStart(2, "0") +
                ":" +
                dt.getMinutes().toString().padStart(2, "0");
            let dtcadastro = date + "T" + time;

            api
                .post(
                    "/v1/operacoes/feedback",
                    {
                        dtlancamento: dtcadastro,
                        positivo: edtpositivo,
                        codsupervisor: codcolaborador,
                        codcolaborador: edtcodcolaborador,
                        feedback: edtfeedback,
                        excluido: "N",
                        codassinante,
                        codempresa: selectedCompany
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    }
                )
                .then(function (response) {
                    alert(response.data);

                    setedtfeedback("");
                })
                .catch(function (err) {
                    console.log("ops! ocorreu um erro: " + err);
                });
        }

    }

    function ListarColaborador() {
        api
            .get("v1/operacoes/colaboradorequipe", {
                params: {
                    codsupervisor: codcolaborador
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaProfissionalEquipe(response.data);
                setlistacolaborador(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function handleAvisoOpen() {
        ListarColaborador();
        setAviso("");
    }

    function handleFeedbackOpen() {
        setedtpositivo("S");
        setedtcodcolaborador(0);
        setedtfeedback("");

        ListarColaborador();
    }

    const handleColaboradorChange = (event) => {
        setedtcodcolaborador(event.target.value); // Armazena "null" para todas as empresas
    };

    return (
        <div className="top-bar">
            <div className="welcome-message d-flex align-items-center">
                <img
                    src={foto && foto.trim && foto.trim() !== "" ? foto : FotoPadrao}
                    alt="Foto do colaborador"
                    className="foto-colaborador"
                />
                <span className="ms-2">
                    Seja bem-vindo, <b>{nomeColaborador}</b>!
                </span>
            </div>

            <div className="actions">
                <span className="d-flex align-items-center"><b>Versão: 0.0.9</b></span>
                <button className="icon-button" onClick={() => { fetchCheckList(); setCheckListModalOpen(true); }}>
                    <i className="fa-solid fa-square-check"></i>
                    {pendentes.checklist > 0 && <span className="badge">{pendentes.checklist}</span>}
                </button>
                <button className="icon-button" onClick={() => { fetchMissoes(); setMissaoModalOpen(true); }}>
                    <i className="fas fa-exclamation-circle"></i>
                    {pendentes.missoes > 0 && <span className="badge">{pendentes.missoes}</span>}
                </button>
                <button className="icon-button" onClick={() => { fetchFeedbacks(); setFeedbackModalOpen(true); ListarTarefas(); }}>
                    <i className="fas fa-comment-alt"></i>
                    {pendentes.mensagens > 0 && <span className="badge">{pendentes.mensagens}</span>}
                </button>
            </div>

            <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja concluir essa tarefa?</p>

                <div className="row">
                    <div className="col-12 mt-3 d-flex justify-content-end">
                        <button
                            className="btn btn-primary me-2"
                            onClick={handleConfirma}
                        >
                            Sim
                        </button>
                        <button className="btn btn-danger" onClick={handleClose}>
                            Não
                        </button>
                    </div>
                </div>
            </PopUp>

            <PopUpRefazer isOpen={isOpenRefazer} onClose={handleCloseRefazer}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja mandar refazer essa tarefa?</p>

                <div className="row">
                    <div className="col-12 mt-3 d-flex justify-content-end">
                        <button
                            className="btn btn-primary me-2"
                            onClick={handleConfirmaRefazer}
                        >
                            Sim
                        </button>
                        <button className="btn btn-danger" onClick={handleCloseRefazer}>
                            Não
                        </button>
                    </div>
                </div>
            </PopUpRefazer>

            {/* Modal Missões */}
            <ModalMissao
                isOpen={missaoModalOpen}
                onRequestClose={() => setMissaoModalOpen(false)}
                overlayClassName="modal-overlay"
                className="modal-content modal-lg">

                <div className="modal-header">
                    <h2>Missões e Desafios</h2>
                    <button type="button" className="btn-close" onClick={() => setMissaoModalOpen(false)}></button>
                </div>

                <div className="modal-body">
                    <div className="input-group">
                        <input type="text" className="form-control" placeholder="Digite sua busca" aria-label="Digite sua busca" value={buscaMissao} onChange={(e) => setBuscaMissao(e.target.value)} />
                        <button className="btn btn-primary" type="button" onClick={fetchMissoes}>Buscar</button>
                    </div>
                    <br />
                    <div className="list">
                        {missoes.map((missao) => (
                            <div
                                className={`list-item ${missao.status === "Aceito" ? "status-aceito" : "status-pendente"
                                    }`}
                                key={missao.codigo}
                                onClick={() => handleMissaoClick(missao)}
                            >
                                <div className="list-header">
                                    <span className="titulo">{missao.titulo}</span>
                                    <span className="details">
                                        <span
                                            className={`status ${missao.status === "Aceito" ? "status-aceito" : "status-pendente"
                                                }`}
                                        >
                                            {missao.status}
                                        </span>
                                        <span
                                            className={`tipo ${missao.tipo === "Missão" ? "tipo-missao" : "tipo-desafio"
                                                }`}
                                        >
                                            {missao.tipo}
                                        </span>
                                    </span>
                                </div>
                                <div className="descricao">{missao.descricao.substring(0, 50)}</div>
                                <div className="datas">
                                    {FormataDataHora(missao.dtinicio)} - {FormataDataHora(missao.dttermino)}
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </ModalMissao>

            {missaoDetalhe && (
                <ModalMissaoDetalhe
                    isOpen={missaoDetalheModal}
                    onRequestClose={() => setMissaoDetalheModal(false)}
                    overlayClassName="modal-overlay"
                    className="modal-content modal-lg">
                    <div className="modal-header">
                        <h2>{missaoDetalhe.titulo}</h2>
                        <button type="button" className="btn-close" onClick={() => setMissaoDetalheModal(false)}></button>
                    </div>
                    <div className="modal-body">
                        {missaoDetalhe.tipo === "Desafio" && <img src={missaoDetalhe.foto} alt="Desafio" className="modal-image" />}
                        <span className="details">
                            <span
                                className={`status ${missaoDetalhe.status === "Aceito" ? "status-aceito" : "status-pendente"
                                    }`}
                            >
                                {missaoDetalhe.status}
                            </span>
                            <span
                                className={`tipo ${missaoDetalhe.tipo === "Missão" ? "tipo-missao" : "tipo-desafio"
                                    }`}
                            >
                                {missaoDetalhe.tipo}
                            </span>
                        </span>
                        <div className="descricao-detalhe">{missaoDetalhe.descricao}</div>
                        <div className="datas">
                            {FormataDataHora(missaoDetalhe.dtinicio)} - {FormataDataHora(missaoDetalhe.dttermino)}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="accept-button"
                            disabled={missaoDetalhe.status === "Aceito"}
                            onClick={() => AceitarMissao(missaoDetalhe)}>Aceitar</button>
                    </div>
                </ModalMissaoDetalhe>)}

            <ModalFeedback
                isOpen={feedbackModalOpen}
                onRequestClose={() => setFeedbackModalOpen(false)}
                overlayClassName="modal-overlay"
                className="modal-content modal-lg"
            >
                <div className="modal-header">
                    <h2>Avisos e Feedbacks</h2>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setFeedbackModalOpen(false)}
                    ></button>
                </div>

                <div className="modal-body">
                    {/* Bootstrap Tabs */}
                    <ul className="nav nav-tabs" id="checklistTabs" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link active"
                                id="lista-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#tarefas"
                                type="button"
                                role="tab"
                                aria-controls="tarefas"
                                aria-selected="true"
                            >
                                Seus Avisos e Feedbacks
                            </button>
                        </li>
                        {isGestor && (
                            <>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="cadfeedback-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#cadfeedback"
                                        type="button"
                                        role="tab"
                                        aria-controls="cadfeedback"
                                        aria-selected="false"
                                        onClick={() => handleFeedbackOpen()}
                                    >
                                        Informar FeedBack
                                    </button>
                                </li>

                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="cadaviso-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#cadaviso"
                                        type="button"
                                        role="tab"
                                        aria-controls="cadaviso"
                                        aria-selected="false"
                                        onClick={() => handleAvisoOpen()}
                                    >
                                        Informar Aviso
                                    </button>
                                </li>
                            </>
                        )}
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content" id="checklistTabsContent">
                        {/* Aba 1: Tarefas */}
                        <div
                            className="tab-pane fade show active"
                            id="tarefas"
                            role="tabpanel"
                            aria-labelledby="lista-tab"
                        >
                            <div className="list">
                                {feedbacks.map((feedback) => (
                                    <div
                                        className="list-item"
                                        key={feedback.codigo}
                                        onClick={() => handleFeedbackClick(feedback)}
                                    >
                                        <div className="list-header">
                                            <span className="descricao-detalhe">
                                                {feedback.texto.substring(0, 50)}
                                            </span>
                                            <span className="details">
                                                <span
                                                    className={`status ${feedback.visualizado === "S"
                                                        ? "status-aceito"
                                                        : "status-pendente"
                                                        }`}
                                                >
                                                    {feedback.visualizado1}
                                                </span>
                                                <span
                                                    className={`tipo ${feedback.tipo === "Missão"
                                                        ? "tipo-missao"
                                                        : "tipo-desafio"
                                                        }`}
                                                >
                                                    {feedback.tipo}
                                                </span>
                                            </span>
                                        </div>
                                        <div className="datas">
                                            {FormataDataHora(feedback.dtvisualizado)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Aba 2: Feedback (Gestor) */}
                        {isGestor && (
                            <>
                                <div
                                    className="tab-pane fade"
                                    id="cadfeedback"
                                    role="tabpanel"
                                    aria-labelledby="cadfeedback-tab"
                                >
                                    <br />

                                    <div className="row">
                                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                            <div>
                                                <label htmlFor="positivo" className="form-label">
                                                    Positivo
                                                </label>
                                                <br />
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="positivo"
                                                        value="S"
                                                        onChange={(e) => setedtpositivo(e.target.value)}
                                                        checked={edtpositivo === "S"}
                                                    />
                                                    <label className="form-check-label">Sim</label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="positivo"
                                                        value="N"
                                                        onChange={(e) => setedtpositivo(e.target.value)}
                                                        checked={edtpositivo === "N"}
                                                    />
                                                    <label className="form-check-label">Não</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
                                            <label htmlFor="colaborador" className="form-label">
                                                Profissional
                                            </label>
                                            <select
                                                className="form-select"
                                                value={edtcodcolaborador}
                                                onChange={handleColaboradorChange}
                                            >
                                                <option value="0">Selecione o profissional</option>
                                                {listacolaborador.map((col, index) => (
                                                    <option key={index} value={col.codfuncionario}>
                                                        {col.nome}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xl-10 col-lg-10 col-md-6 col-sm-12">
                                            <label htmlFor="feedback" className="form-label">
                                                Feedback
                                            </label>
                                            <input
                                                type="text"
                                                id="feedback"
                                                className="form-control"
                                                placeholder="Feedback"
                                                value={edtfeedback}
                                                onChange={(e) => setedtfeedback(e.target.value)}
                                            />
                                        </div>

                                        <div
                                            className="col-xl-2 col-lg-2 col-md-6 col-sm-12"
                                        >
                                            <button className="btn btn-primary"
                                                type="button"
                                                onClick={() => EnviarFeedBack()}>
                                                Enviar Feedback
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Aba 3: Aviso (Gestor) */}
                                <div
                                    className="tab-pane fade"
                                    id="cadaviso"
                                    role="tabpanel"
                                    aria-labelledby="cadaviso-tab"
                                >

                                    <br />

                                    <div className="row">
                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                            <label htmlFor="setor" className="form-label">
                                                Profissional
                                            </label>
                                            <select
                                                className="form-select"
                                                id="profissional"
                                                value={codcolaboradorequipe}
                                                onChange={(e) => setcodcolaboradorequipe(e.target.value)}
                                            >
                                                <option value="0">Escolha o Profissional</option>
                                                {listaProfissionalEquipe.map(function (equi) {
                                                    return (
                                                        <option
                                                            key={equi.codequipefuncionario}
                                                            value={equi.codfuncionario}
                                                        >
                                                            {equi.nome}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>

                                        <div className="col-xl-6 col-lg-6 col-md-4 col-sm-12">
                                            <label className="form-label" htmlFor="aviso">
                                                Aviso
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Escreva o aviso aqui"
                                                name="aviso"
                                                id="aviso"
                                                className="form-control me-3"
                                                value={aviso}
                                                onChange={(e) => setAviso(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-xl-2 col-lg-2 col-md-4 col-sm-12">
                                            <button
                                                className="btn btn-primary"
                                                type="button"
                                                onClick={() => GerarAviso()}
                                            >
                                                Enviar Aviso
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </ModalFeedback>

            {feedbackDetalhe && (
                <ModalFeedbackDetalhe
                    isOpen={feedbackDetalheModal}
                    onRequestClose={() => setFeedbackDetalheModal(false)}
                    overlayClassName="modal-overlay"
                    className="modal-content modal-lg">

                    <div className="modal-header">
                        <h2>{feedbackDetalhe.tipo}</h2>
                        <button type="button" className="btn-close" onClick={() => setFeedbackDetalheModal(false)}></button>
                    </div>

                    <div className="modal-body">
                        <div className="descricao-detalhe">{feedbackDetalhe.texto}</div>
                    </div>

                </ModalFeedbackDetalhe>)}

            <ModalCheckList
                isOpen={checkListModalOpen}
                onRequestClose={() => setCheckListModalOpen(false)}
                overlayClassName="modal-overlay"
                className="modal-content modal-lg">

                <div className="modal-header">
                    <h2>Tarefas</h2>
                    <button type="button" className="btn-close" onClick={() => setCheckListModalOpen(false)}></button>
                </div>

                <div className="modal-body">
                    {/* Bootstrap Tabs */}
                    <ul className="nav nav-tabs" id="checklistTabs" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link active"
                                id="tarefas-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#tarefas"
                                type="button"
                                role="tab"
                                aria-controls="tarefas"
                                aria-selected="true">
                                Suas Tarefas
                            </button>
                        </li>
                        {isGestor && (
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link"
                                    id="gestao-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#gestao"
                                    type="button"
                                    role="tab"
                                    aria-controls="gestao"
                                    aria-selected="false">
                                    Tarefas Feitas
                                </button>
                            </li>
                        )}
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content" id="checklistTabsContent">
                        {/* Aba 1: Tarefas */}
                        <div
                            className="tab-pane fade show active"
                            id="tarefas"
                            role="tabpanel"
                            aria-labelledby="tarefas-tab">
                            <div className="list mt-3">
                                {checklist.map((check) => (
                                    <div
                                        className="list-item"
                                        key={check.codchecklist}
                                        onClick={() => {
                                            setCheckListDetalheModal(true); setCheckListDetalhe(check); setCheckListDetalheGestor(true); setObservacao("");
                                            setJustificativa("");
                                        }}
                                    >
                                        <div className="list-header">
                                            <div className="descricao-container">
                                                <span className="descricao-gestor">Solicitante: {check.gestor} - Valor: {check.coinssomar} coins</span>
                                                <span className="descricao-detalhe">{check.tarefa.substring(0, 50)}</span>
                                            </div>
                                            <span className="details">
                                                <span
                                                    className={`status ${check.visualizado === "S" ? "status-aceito" : "status-pendente"}`}
                                                >
                                                    {check.visualizado1}
                                                </span>
                                                <span
                                                    className={`tipoCheckList ${check.tipo === "Dentro do prazo"
                                                        ? "tipo-dentro-prazo"
                                                        : check.tipo === "O prazo é até hoje"
                                                            ? "tipo-prazo-hoje"
                                                            : "tipo-prazo-venceu"
                                                        }`}
                                                >
                                                    {check.tipo}
                                                </span>
                                            </span>
                                        </div>
                                        <div className="datas">
                                            {FormataData(check.dttarefa)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Aba 2: Gestão de Tarefas (apenas para gestores) */}
                        {isGestor && (
                            <div
                                className="tab-pane fade"
                                id="gestao"
                                role="tabpanel"
                                aria-labelledby="gestao-tab">

                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                        <label className="form-label" htmlFor="busca">
                                            Busque aqui
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Buscar por: Código, Gestor ou nome do profissional"
                                            name="busca"
                                            id="busca"
                                            className="form-control me-3"
                                            value={abusca}
                                            onChange={(e) => setabusca(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <label htmlFor="dtlancamento" className="form-label">
                                            Dt. Início
                                        </label>
                                        <input
                                            type="date"
                                            id="dtlancamento"
                                            className="form-control"
                                            placeholder="Dt. Lançamento"
                                            value={dt1}
                                            onChange={(e) => setdt1(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <label htmlFor="dtlancamento" className="form-label">
                                            Dt. Término
                                        </label>
                                        <input
                                            type="date"
                                            id="dtlancamento"
                                            className="form-control"
                                            placeholder="Dt. Lançamento"
                                            value={dt2}
                                            onChange={(e) => setdt2(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="list mt-3">
                                    {tarefasEquipe.map((tarefa) => (
                                        <div
                                            className="list-item"
                                            key={tarefa.codchecklist}
                                        >
                                            <div className="list-header">
                                                <div className="descricao-container">
                                                    <span className="descricao-gestor">Profissional: {tarefa.colaborador}</span>
                                                    <span className="descricao-detalhe">{tarefa.tarefa.substring(0, 50)}</span>
                                                </div>
                                                <span className="details">
                                                    <span
                                                        className="status status-pendente"
                                                    >
                                                        Periodicidade: {tarefa.tipoperiodicidade}
                                                    </span>
                                                    <span
                                                        className="tipoCheckList tipo-dentro-prazo"
                                                    >
                                                        Valor Coins: {tarefa.coinssomar}
                                                    </span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="datas2">
                                                        Data da Tarefa: {FormataData(tarefa.dttarefa)}
                                                    </div>
                                                    <div className="datas2">
                                                        Quando foi Feito: {FormataData(tarefa.dttarefafeito)}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="acoes">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-success me-2"
                                                            onClick={() => concluirTarefa(tarefa)}
                                                        >
                                                            <i className="bi bi-check-circle"></i> Concluir
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-warning me-2"
                                                            onClick={() => refazerTarefa(tarefa)}
                                                        >
                                                            <i className="bi bi-check-circle"></i> Refazer
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => visualizarDetalhes(tarefa)}
                                                        >
                                                            <i className="bi bi-eye"></i> Detalhes
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </ModalCheckList>

            <ModalQualificacao
                isOpen={showformqualificacao}
                onRequestClose={closeModalQualificacao}
                className="modal-sm"
                overlayClassName="modal-overlay"
                contentLabel="Qualificação"
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Qualificação</h5>
                        <button type="button" className="btn-close" onClick={closeModalQualificacao}></button>
                    </div>
                    <div className="modal-body">
                        {/* Totalizadores */}
                        <div className="row">
                            <div className="">
                                <label className="form-label" htmlFor="coin">Coins creditado</label>
                                <input className="form-control"
                                    type="text"
                                    name="coin"
                                    id="coin"
                                    value={coin}
                                    onChange={(e) => setCoin(e.target.value)}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-auto">
                                <div className="card mt-2">
                                    <div className="card-body text-center">
                                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                                            {['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'].map((val) => (
                                                <label
                                                    key={val}
                                                    className={`d-flex align-items-center justify-content-center rounded-3 cursor-pointer transition 
                      ${qualificacao === val
                                                            ? 'bg-primary text-white'
                                                            : 'bg-light text-dark hover-bg-gray'}`}
                                                    style={{ width: '3rem', height: '3rem', cursor: 'pointer' }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="qualificacao"
                                                        value={val}
                                                        checked={qualificacao === val}
                                                        onChange={(e) => { setQualificacao(e.target.value); setCoinCalculado((coin * e.target.value) / 10); }}
                                                        className="d-none"
                                                    />
                                                    <span className="fs-4 mb-0">{val}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="">
                                <label className="form-label" htmlFor="coincalculado">Coins creditado</label>
                                <input className="form-control"
                                    type="text"
                                    name="coincalculado"
                                    id="coincalculado"
                                    value={coincalculado}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" className="btn btn-secondary" onClick={closeModalQualificacao}>
                            Fechar
                        </button>
                        <button type="button" className="btn btn-success" onClick={InformarConclusao}>
                            Informar
                        </button>
                    </div>
                </div>
            </ModalQualificacao>

            {checkListDetalhe && (
                <ModalCheckListDetalhe
                    isOpen={checkListDetalheModal}
                    onRequestClose={() => setCheckListDetalheModal(false)}
                    overlayClassName="modal-overlay"
                    className="modal-content modal-lg">

                    <div className="modal-header">
                        <h2>Tarefa</h2>
                        <button type="button" className="btn-close" onClick={() => setCheckListDetalheModal(false)}></button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <label className="form-label" htmlFor="tafera">
                                    Tarefa
                                </label>
                                <br />
                                <span className="descricao-detalhe">{checkListDetalhe.tarefa}</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <label className="form-label" htmlFor="valor">
                                    Valor
                                </label>
                                <br />
                                <span className="descricao-detalhe">{checkListDetalhe.coinssomar}</span>
                            </div>
                        </div>

                        {checkListDetalheGestor ? (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="form-label" htmlFor="justificativa">
                                            Justificativa
                                        </label>
                                        <input className="form-control"
                                            type="text"
                                            name="justificativa"
                                            id="justificativa"
                                            placeholder="Justificativa"
                                            value={justificativa}
                                            onChange={(e) => setJustificativa(e.target.value)} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="form-label" htmlFor="observacao">
                                            Observação
                                        </label>
                                        <input className="form-control"
                                            type="text"
                                            name="observacao"
                                            id="observacao"
                                            placeholder="Observação"
                                            value={observacao}
                                            onChange={(e) => setObservacao(e.target.value)} />
                                    </div>
                                </div>
                            </>)
                            :
                            (<>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="form-label" htmlFor="justificativa">
                                            Justificativa
                                        </label>
                                        <input className="form-control"
                                            type="text"
                                            name="justificativa"
                                            id="justificativa"
                                            placeholder="Justificativa"
                                            value={justificativa}
                                            disabled />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="form-label" htmlFor="observacao">
                                            Observação
                                        </label>
                                        <input className="form-control"
                                            type="text"
                                            name="observacao"
                                            id="observacao"
                                            placeholder="Observação"
                                            value={observacao}
                                            disabled />
                                    </div>
                                </div>
                            </>)}
                    </div>

                    {checkListDetalheGestor ? (
                        <div className="modal-footer">
                            <button className="accept-button" type="button" onClick={() => handleCheckListClick(checkListDetalhe)}>Finalizar Tarefa</button>
                        </div>) : null}

                </ModalCheckListDetalhe>)}
        </div>
    );
}

export default TopBar;
